<template><div></div></template>

<script>
import { mapGetters } from 'vuex'
import { homePathOf } from '@/utils/adminRole'

/**
 * 로그인 뒤 역할별 홈으로 보내는 자리. 갈 곳의 정본은 `utils/adminRole` 한 곳이다 —
 * 역할 문자열 비교를 이 컴포넌트가 다시 적지 않는다(콜팝 역할 4종이 들어오며 정리, B2).
 */
export default {
  computed: {
    ...mapGetters({
      authId: 'auth/authId',
    }),
  },
  watch: {
    authId: {
      handler(val) {
        if (!val) return

        const path = homePathOf(val)
        // `admin`·`mng` 는 갈 곳이 없다 — 종전처럼 이 화면에 머문다
        if (!path) return

        this.$router.push(path).catch(() => {})
      },
      immediate: true,
    },
  },
}
</script>
